<template>
    <div class="panel">
        <div class="panel__header">
            <h2>
                <i class="panel__header__icon icons icon-paper-plane"></i>
                <span>{{$t('dashboard.applications.title')}}</span>
            </h2>
            <div @click.prevent="addNew" class="panel_header__action">
                <i class="panel_header__action__icon icons icon-plus"></i>
                <a class="button--link hidden-xs">{{$t('dashboard.applications.add_new')}}</a>
            </div>
        </div>
        <div class="panel__body">
            <applications-table />
        </div>
        <application-modal />
        <application-attachments-modal />
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import ApplicationsTable from '@/components/tables/dashboard/ApplicationsTable';
    import ApplicationModal from '@/components/modals/dashboard/ApplicationModal';
    import ApplicationAttachmentsModal from '@/components/modals/dashboard/ApplicationAttachmentsModal';

    import Application from '@/models/Application';

    @Component({
        components: {
            ApplicationsTable,
            ApplicationModal,
            ApplicationAttachmentsModal
        }
    })
    export default class ApplicationsPanel extends Vue {
        name = 'applications-panel';

        addNew() {
            const url = `/trajectories/${this.$store.state.trajectory.trajectory.id}/applications`;
            const application = new (Application.makeModel(url));
            this.$modal.show('application-modal', { application });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/ApplicationsPanel.vue